var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCategoryCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10L14.5 19H25.5L20 10ZM20 13.84L21.93 17H18.06L20 13.84ZM25.5 21C23.01 21 21 23.01 21 25.5C21 27.99 23.01 30 25.5 30C27.99 30 30 27.99 30 25.5C30 23.01 27.99 21 25.5 21ZM25.5 28C24.12 28 23 26.88 23 25.5C23 24.12 24.12 23 25.5 23C26.88 23 28 24.12 28 25.5C28 26.88 26.88 28 25.5 28ZM11 29.5H19V21.5H11V29.5ZM13 23.5H17V27.5H13V23.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategoryCircle40Px);
export default __webpack_public_path__ + "static/media/ic_category_circle-40px.c808fb71f5f93dd8d6295d4bea67aca2.svg";
export { ForwardRef as ReactComponent };